import { PairedCostFeatures } from '@aloft/toolkit-shared';

import { get } from 'lodash';

import { Tkv2OrderContext } from '../../../../controller/types.js';

export const getFeatureValue = <T extends keyof PairedCostFeatures>(
  context: Tkv2OrderContext,
  compID: string,
  featureKey: T,
): PairedCostFeatures[T] => {
  if (compID === 'subject') {
    return get(context, `pairedCostResults.subject.features.${featureKey}`);
  }

  return get(context, `pairedCostResults.comps.${compID}.features.${featureKey}`);
};
